var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17.414 26 4.293 4.293a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 1.414L17.414 24H23a7 7 0 0 0 7-7v-2a7 7 0 0 0-7-7h-1V6h1a9 9 0 0 1 9 9v2a9 9 0 0 1-9 9zM14.586 6l-4.293-4.293A1 1 0 1 1 11.707.293l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414-1.414L14.586 8H9a7 7 0 0 0-7 7v2a7 7 0 0 0 7 7h1v2H9a9 9 0 0 1-9-9v-2a9 9 0 0 1 9-9z"
})));
export default SvgRebook;